<template>
	 <div class="container">
        <div class="content">

            <section >

                <p class="gif-container">
                    <img src="https://api.quomi.it/oldimg/spiaggia2.jpg" width='300' >
                </p>

                <div>
                    <h2
                        class="center"
                        v-html="`Sospensione consegna nel periodo estivo`"
                    />
                    <p>
                    	Ciao <b>{{ user.firstname }}</b>, <br>
                    	<p style="max-width: 800px" class="ma-auto">
                    		<b>il servizio Quomi sarà sospeso su alcune zone di consegna</b>, inclusa la tua, per tutto il periodo estivo.<br><br>
							Per noi di Quomi la cosa più importante è riuscire a darti sempre la <b>massima garanzia di sicurezza e professionalità</b>.<br><br>
							Per questo motivo la sospensione è necessaria <b>per garantire il massimo della qualità degli ingredienti spediti</b>, specialmente nei periodi più caldi.<br><br>
							Siamo molto dispiaciuti di non poterti più servire durante questi mesi ma <b>ti avviseremo non appena riattiveremo il servizio sulla tua località (tante gustose novità ti attenderanno al tuo ritorno 😉.</b><br><br>
							
							Nel frattempo puoi continuare a navigare  <router-link class="link-detail" :to="{'name': 'cookbook'}">il nostro ricettario</router-link>  per trovare idee e ispirazione per le tue cene estive!<br><br>
              
              <router-link
                :to="{ name: 'cookbook' }"
              >
                <CTA
                  class="ma-auto"
                  :content="`Vai al ricettario`"
                  isArrow
                />
              </router-link>
              <br>

							Per ogni ulteriore richiesta non esitare a contattare il nostro servizio clienti utilizzando la pagina di <router-link class="link-detail" :to="{'name': 'freshdesk'}">supporto</router-link>.

							<br><br>
              <router-link
                :to="{ name: 'freshdesk' }"
              >
                <CTA
                  class="ma-auto"
                  :content="`Vai al supporto`"
                  isArrow
                />
              </router-link>
              <br>

                    	</p>
                    </p>	
                </div>
            </section>
         </div>
    </div>
</template>

<script>
export default {
	computed: {
        user () {
            return this.$root.user
        }
    }
}

</script>

<style scoped>
    .label {
        background-color: #fbf1d7;
        max-width: 500px;
        margin: 0 auto;
        margin-bottom: 10px;
    }

    .content {
        padding: 30px 15px 30px 15px;
        text-align: center;
        width: 100%;
        max-width: 100%;
    }

    .gif-container {
        margin: 0 auto;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .gif-container img {
        max-width: inherit;
        margin-left: -16px;
    }

    .container-faq {
        max-width: 1200px;
        width: 90%;
        margin: 0 auto;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    h2 {
        padding-bottom: 10px;
    }

    h3 {
        font-size: 20px;
    }

    .red-text {
        margin: 0 auto;
        display: block;
        font-size: 15px;
        font-weight: bold;
    }

    section {
        padding: 0px 0;
        width: 100%;
        margin: 0 auto;
    }
</style>
